var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.06051 7.99985L13.5302 12.4695C14.2373 13.1766 13.1766 14.2373 12.4695 13.5302L7.99985 9.06051L3.53018 13.5302C2.82307 14.2373 1.76241 13.1766 2.46952 12.4695L6.93919 7.99985L2.46952 3.53018C1.76241 2.82307 2.82307 1.76241 3.53018 2.46952L7.99985 6.93919L12.4695 2.46952C13.1766 1.76241 14.2373 2.82307 13.5302 3.53018L9.06051 7.99985Z", fill: "#767676" })
  );
});